import React from 'react'
import MainContentsWithSidebarInbox from 'components/templates/MainContentsWithSidebarInbox'
import ModalSelect from 'components/organisms/ModalSelect'
import LoadingView from 'components/atoms/LoadingView'

type PropTypes = {
  sidebarComponent: ?any,
  isShowContentsSp?: ?boolean,
  isModalActive?: ?boolean,
  isLoading?: ?boolean,
  modal: {
    title: string,
    desc: string,
    positiveButton: {
      text: string,
      onClick: Function,
    },
  },
  closeModal: Function,
  isButtonTwoBlock?: ?boolean,
  attentionText?: ?string,
}

export default function ReservationChangeHostPage(props: PropTypes) {
  return (
    <React.Fragment>
      <MainContentsWithSidebarInbox
        sidebarInbox={props.sidebarComponent}
        isShowContentsSp={props.isShowContentsSp}
      >
        {props.children}
      </MainContentsWithSidebarInbox>
      <ModalSelect
        title={props.modal.title}
        textList={[props.modal.desc]}
        positiveButton={props.modal.positiveButton}
        negativeButton={{
          text: i18n.t('page.shared.cancel'),
          onClick: props.closeModal,
        }}
        isActive={!!props.isModalActive}
        onClickClose={props.closeModal}
        isButtonTwoBlock={props.isButtonTwoBlock}
        attentionText={props.attentionText}
      />
      {props.isLoading && <LoadingView />}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/ReservationChangeHostPage/index.jsx